module.exports = __webpack_public_path__ + "static/MEDICI_default-5972f772e7e64f14d711c84011e9775f.webp";